"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section ref={ref} className="relative flex min-h-screen w-full items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1516646/img/hvac_technicians_at_work_hero.png)",
      backgroundAttachment: "fixed"
    }} />

      {}
      <div className="absolute inset-0 bg-white/75" />

      {}
      <div className={`relative z-10 mx-auto max-w-4xl px-6 text-center transition-all duration-[150ms] ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-2.5 opacity-0"}`}>
        <h1 className="mb-4 text-5xl font-bold leading-tight text-foreground md:text-6xl lg:text-7xl">
          Expert HVAC Solutions in Pittsburgh
        </h1>
        <p className="text-xl leading-relaxed text-foreground md:text-2xl lg:text-3xl">
          Precision craftsmanship and reliable climate control for your home or business
        </p>
      </div>

      {}
      <style>{`
        @media (prefers-reduced-motion: reduce) {
          [style*="background-attachment: fixed"] {
            background-attachment: scroll !important;
          }
        }
      `}</style>
    </section>;
}